import { useCallback, useContext } from 'react';
import {
  CheckoutContext,
  CheckoutState,
} from '../../context/CheckoutContext/context';
import useCheckoutPagination from './useCheckoutPagination';

function useCheckoutState() {
  const pagination = useCheckoutPagination();
  const { state, dispatch } = useContext(CheckoutContext);

  const setSelectedPaymentsGroup = useCallback(
    (payload: CheckoutState['selectedPaymentsGroup']) => {
      dispatch({ type: 'SET_SELECTED_PAYMENTS_GROUP', payload });
    },
    [dispatch],
  );

  return {
    selectedPaymentsGroup: state.selectedPaymentsGroup,
    setSelectedPaymentsGroup,
    pagination,
  };
}

export default useCheckoutState;
